


import api from './api';
import drupal from '../utils/drupal';

var jwt_decode = require('jwt-decode');



// Alias
let AsyncStorage = window.localStorage;


//Auth Middleware Class
class AuthMiddleware {

  constructor() {
    this.jwt = null;
    this.refreshToken = null;
  }

  use(fn) {
    this.go = ((stack) => (next) => stack(() => fn.call(this, next.bind(this))))(this.go);
  }

  go = (next) => next()

};


//Export our JWT Auth Middleware
export default function authMiddleware(promise, data) {

  let middleware = new AuthMiddleware();

  //Promise to return for Redux Promise Middleware
  return new Promise( async (resolve, reject) => {

    //Set Token Check Middleware
    middleware.use( async (next) => {

      let jwt;
      let refreshToken;

      // try get JWT
      try {
        jwt = AsyncStorage.getItem('jwt');
      } catch (error) {
        return next();
      }

      // try get refreshToken
      try {
        refreshToken = AsyncStorage.getItem('refreshToken');
      } catch (error) {
        return next();
      }

      if(!jwt || !refreshToken) {
        return next();
      }

      //Check if we need new Auth Token
      var decoded = jwt_decode(jwt);
      let now = Date.now();
      let expiration = new Date(decoded.exp * 1000).getTime();

      //subtract some buffer time, 30 mins
      expiration -= (30 * 60 * 1000);

      // JWT is still Valid
      if(expiration > now) {
        middleware.jwt = jwt; //use current auth
        middleware.refreshToken = refreshToken;
        return next();
      }

      let newAuth;

      //Fetch New Auth Data with Refresh Token
      try {
        newAuth = await getNewToken(refreshToken);
      } catch(err) {
        return next();
      }

      //console.log('New Auth', newAuth);

      // set new jwt
      middleware.jwt = newAuth.access_token;

      //Set New JWT token
      await AsyncStorage.setItem('jwt', newAuth.access_token);

      // continue
      return next();

    });

    //Call Api with Valid JWT
    middleware.go( async () => {

      // If Auth not given just run query without it
      if(!middleware.jwt) {
        return resolve(promise({ ...data }));
      }

      data.jwt = middleware.jwt;
      const refreshToken = middleware.refreshToken;

      // Try Run our Query
      tryUntil(promise, data, refreshToken, 5).then(result => {
        return resolve(result);
      }).catch(err => {
        return reject(err);
      });

    });

  });

}


// Check if JWT Expired Error
function getJwtError(err) {

  if(err === "invalid_token" ||
     err === "The access token provided has expired" ||
     err === "The access token provided is invalid" ||
     err.error === "invalid_token") {

    return true; // is a jwt error
  }

  // Extra catch
  if(err.toString().toLowerCase().includes('token')) {
    return true;
  }

  return false; // not jwt error

}



async function tryUntil(promise, data, refreshToken, nTimes = 3) {
  return new Promise( async (resolve, reject) => {

    let i = 0;
    let wait = 3000;
    let increase = 2;
    let result;
    let finalErr;

    // try until we get result
    while (i < nTimes) {
      try {
        result = await promise({ ...data });
        return resolve(result);
      } catch(err) {

        // if JWT Error, try again
        if(getJwtError(err)) {
          let newAuth = await getNewToken(refreshToken); // get new JWT
          await AsyncStorage.setItem('jwt', newAuth.access_token); // set new JWT
          data.jwt = newAuth.access_token; // try again with new JWT
        } else {
          // if not JWT error, just exit early
          return reject(err);
        }

        i++; // increment try count
        finalErr = err;
        await timeout(wait); // wait a bit
        wait = wait * increase; // increase wait time

      }
    }

    //
    return reject(finalErr);

  });
}

async function timeout(ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => { return resolve(); }, ms);
  });
}

// async function getCsrf() {
//   return new Promise( async (resolve, reject) => {
//
//     try {
//
//       let csrf = await get({
//         endpoint: '/services/session/token',
//         data: {},
//         headers: {},
//       });
//
//       csrf = csrf.trim();
//       return resolve(csrf);
//
//     } catch(err) {
//       return reject('There was an error logging in');
//     }
//
//
//   });
// }

// Get New JWT using Refresh Token
function getNewToken(refreshToken) {
  return new Promise( async (resolve, reject) => {

    // Get new Auth Data
     api.post("/api/auth/login", {
       "refresh_token": refreshToken,
     }, {
       headers: {},
     }).then(result => {

       //Check for errors
       if(!result.ok) {
         return reject(drupal.getError(result));
       }

       //Success
       if(result.ok) {
         return resolve(result.data);
       }

     }).catch(err => {
       return reject(err);
     });

  });
}



function get(options, defaultErr = "There was an error making that request") {
  return new Promise(function(resolve, reject) {
    const { endpoint, headers } = options;
    api.get(endpoint, {}, { headers }).then(result => {
      //alert(JSON.stringify(result, null, 2));
      if(!result.ok) {
        return reject(drupal.getError(result, defaultErr));
      }
      return resolve(result.data);
    }).catch(err => {
      return reject(err);
    });
  });
}



// WEBPACK FOOTER //
// ./src/api/AuthMiddleware.js